module.exports = __webpack_public_path__ + "img/bgimage4.b64b411a.png";